import React, { useEffect, useRef } from "react";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import BlurLinearIcon from "@material-ui/icons/BlurLinear";
import { modes } from "../data/TransactionTypes";
import { Link } from "react-router-dom";

function TransItem({ title, items }) {
  const [check, setCheck] = React.useState(false);

  return (
    <div
      style={{
        paddingLeft: "2rem",
      }}
    >
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setCheck(!check)}
      >
        <h5 className="text-xs uppercase py-3 font-bold block">{title}</h5>

        <div className="flex items-center">
          {check ? (
            <KeyboardArrowDownIcon style={{ fontSize: "1.5rem" }} />
          ) : (
            <KeyboardArrowRightIcon style={{ fontSize: "1.5rem" }} />
          )}
        </div>
      </div>
      {check && (
        <ul
          style={{
            paddingLeft: "1rem",
          }}
        >
          {items.map((item, id) => {
            return (
              <li key={id}>
                <Link
                  className={
                    "text-xs py-2 uppercase font-bold block " +
                    (window.location.href.indexOf(`${item.url}`) !== -1
                      ? "text-blue-500 hover:text-blue-600"
                      : "text-gray-800 hover:text-gray-600")
                  }
                  to={item.url}
                >
                  {item.title}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default function TranSidebar() {
  const [tran, setTran] = React.useState(false);

  return (
    <div>
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setTran(!tran)}
      >
        <div className="flex items-center ">
          <BlurLinearIcon className="mr-2" />
          <h5 className="text-xs uppercase py-3 font-bold block">
            Transaction
          </h5>
        </div>
        <div className="flex items-center">
          {tran ? (
            <KeyboardArrowDownIcon style={{ fontSize: "1.5rem" }} />
          ) : (
            <KeyboardArrowRightIcon style={{ fontSize: "1.5rem" }} />
          )}
        </div>
      </div>

      {tran &&
        modes.map((mode, i) => {
          return (
            <TransItem
              key={i}
              title={Object.keys(mode)[0].toString()}
              items={mode[Object.keys(mode)[0]]}
            />
          );
        })}
    </div>
  );
}
